export default "__VITE_PUBLIC_ASSET__028de90c__"